<template>
  <div class="bg-nosotros-trabaja">
    <el-row :gutter="20">
      <!-- <el-col :md="10" :xs="24" data-aos="fade-right" class="centrado" style="display: flex; justify-content: center; align-items: center; height: 300px">
        <h1 style="font-size: 2.5rem; color: white; font-family: 'roboto-black'">{{ $t('nosotros.titulo') }}</h1>
        <div style="float: inline-end; padding-right: 50%; font-size: 1.5rem; color: white" class="vl"></div>
      </el-col> -->

      <el-col :md="24" :xs="24" data-aos="fade-right">
        <div>
          <div class="trabajo-css" v-html="$t('trabaja_nosotros.titulo')"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  mounted() {
    AOS.init({
      duration: 1000, // velocidad de la animación (ms)
      offset: 100, // distancia antes de activar
      once: false, // si lo ponés en true solo se anima 1 vez
    })
  },
}
</script>

<style lang="scss">
.centrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cuadro {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  min-height: 200px;
  width: 220px;
  margin: 0 auto;
  float: left;
  // margin-right: 40px;
  font-weight: 300;
  padding: 30px;
  font-size: 20px;
}
.ml20 {
  margin-right: 35px;
}

.cuadro h3 {
  font-weight: 300;
  margin: 0;
  font-size: 28px;
}

.cuadro ul {
  list-style: none;
  padding: 0;
  // margin: 0;
}

.cuadro ul > li {
  font-size: 20px;
}

.bg-nosotros-trabaja {
  background-color: #d35915;
  position: relative;
  z-index: 999;
  padding: 4% 10%;

  // height: 45vh;
  // padding-top: 30px;
  // padding: 60px 10px;
}

.vl {
  border-left: 3px solid rgb(255, 255, 255);
  height: 300px;
  position: absolute;
  left: 100%;
  // margin-left: -3px;
  top: 0;
}
</style>

<style>
.trabajo-css {
  margin: 0 auto;
  color: #fff;
  font-weight: 300;
  line-height: 1.5;
  /* font-size: 0.9rem; */
  font-family: 'roboto-regular';
  /* padding: 5% 5% 5% 10%; */
  text-align: justify;
  /* hyphens: auto; */
}
@media (min-width: 2561px) {
  .trabajo-css {
    font-size: 29px;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .trabajo-css {
    font-size: 25px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .trabajo-css {
    font-size: 23px;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .trabajo-css {
    font-size: 21px;
  }
  .bg-nosotros-trabaja {
    padding: 4% 11% 4% 11%;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .trabajo-css {
    font-size: 18px;
    /* padding: 3% 10% 3% 10%; */
  }
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .trabajo-css {
    font-size: 19px;
    text-align: left;

    /* padding: 12% 10% 12% 10%; */
  }
  .bg-nosotros-trabaja {
    padding: 12% 10% 12% 10%;
  }
}
@media (max-width: 375px) {
  .trabajo-css {
    font-size: 19px;
    text-align: left;
    /* padding: 12% 10% 12% 10%; */
  }
  .bg-nosotros-trabaja {
    padding: 12% 10% 12% 10%;
  }
}
</style>
